import Vue from 'vue'
import VueRouter from 'vue-router'

import Index from '../views/Index.vue'
import BKTable from '../views/BKTable.vue'
import BKBell from '../views/BKBell.vue'
import BKMenu from '../views/BKMenu.vue'
import Config from '../views/Config.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Index',
        component: Index
    },
    {
        path: '/bktable',
        name: 'BKTable',
        component: BKTable
    },
    {
        path: '/bkbell',
        name: 'BKBell',
        component: BKBell
    },
    {
        path: '/bkmenu',
        name: 'BKMenu',
        component: BKMenu
    },
    {
        path: '/config',
        name: 'Config',
        component: Config
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router


// const router = new VueRouter({
//     mode: 'history',
//     // mode: 'hash',
//     base: process.env.BASE_URL,
//     routes,
//     scrollBehavior(to, from, savedPosition) {
//         // always scroll to top
//         console.log(from.name + "->" + to.name);
//         if (savedPosition != null) {
//             console.log(savedPosition);
//         }

//         return { top: 0 }
//     },
// })

// export default router